// AWS Amplify v6 Configuration for Cognito Authentication
// Using deployed Cognito resources - REVERTED TO WORKING CONFIGURATION

const awsConfig = {
  Auth: {
    Cognito: {
      // Cognito User Pool configuration (original working values with EntraID)
      userPoolId:
        process.env.REACT_APP_USER_POOL_ID || "ap-southeast-2_K3e1IldD2",
      userPoolClientId:
        process.env.REACT_APP_USER_POOL_CLIENT_ID || "6oo6pcd2vthh0j05u85qm21n5u",

      // Cognito Identity Pool configuration (original working values)
      identityPoolId:
        process.env.REACT_APP_IDENTITY_POOL_ID || "ap-southeast-2:4b3c9836-3ab5-40f2-b2ab-8469c475c9f0",

      // OAuth configuration for Hosted UI with EntraID support
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_USER_POOL_DOMAIN || "rss-aggregator-admin-3841.auth.ap-southeast-2.amazoncognito.com",
          scopes: ["email", "openid", "profile", "aws.cognito.signin.user.admin"],
          redirectSignIn: [
            "http://localhost:3000/admin",
            "https://cloudwatch.info/admin",
            "https://uat.cloudwatch.info/admin",
            "https://d3rgldz7x8q2oe.cloudfront.net/admin"
          ],
          redirectSignOut: [
            "http://localhost:3000",
            "https://cloudwatch.info",
            "https://uat.cloudwatch.info",
            "https://d3rgldz7x8q2oe.cloudfront.net"
          ],
          responseType: "code",
          // Support both Cognito and EntraID identity providers
          identityProviders: ["COGNITO", "EntraID"],
        },
      },
    },
  },
};

export default awsConfig;
